/**************************************************
 * Nombre:       Casilla_Funcion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {TableCell, Typography} from "@mui/material";
import {COLORTEXTO} from "../../../Constantes";

const Casilla_Funcion = ({dato, dir, funcion=null}) => {

    return (
        <TableCell key={dato} variant={'body'} align={dir} sx={{color: COLORTEXTO, fontSize: 14, fontWeight: 500}}>
            <Typography sx={{
                fontSize: 14, textOverflow: "ellipsis",
                display: '-webkit-box',
                overflow: 'hidden',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: 3
            }}>{funcion(dato)}</Typography>

        </TableCell>

    )

}
export default Casilla_Funcion